import React from "react";
import TableRow from "../molecules/TableRow";

const RecruitmentsTable = ({ requests, selectedRequest, onSelectRequest }) => {
  return (
    <div className="overflow-hidden bg-white rounded shadow-md">
      <div className="relative overflow-x-auto max-h-[75vh] w-full">
        <table className="min-w-[900px] w-full border-collapse table-auto">
          <thead className="sticky top-0 z-10 bg-gray-100">
            <tr>
              <th className="w-10 p-2 text-left bg-gray-100"></th>
              {[
                "Request ID",
                "Created At",
                "Department",
                "Position Type",
                "Assigned",
                "Position Title",
                "Status",
              ].map((h, i) => (
                <th
                  key={i}
                  className="px-4 py-3 text-sm font-semibold text-left text-gray-700 whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y">
            {Array.isArray(requests) && requests.length > 0 ? (
              requests.map((request) => (
                <TableRow
                  key={request.requestId}
                  request={request}
                  isSelected={selectedRequest?.requestId === request.requestId}
                  onSelect={onSelectRequest}
                />
              ))
            ) : (
              <tr>
                <td colSpan={8} className="p-4 text-center text-gray-500">
                  No requests available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecruitmentsTable;
